import { createStore as reduxCreateStore, combineReducers, applyMiddleware } from 'redux'
import { connectRouter, routerMiddleware } from 'connected-react-router'
import thunk from 'redux-thunk'

import { UsersReducer, AccountsReducer } from '../modules/reducers'

export default function createStore(history) {
  return reduxCreateStore(
    combineReducers({
      router: connectRouter(history),
      users: UsersReducer,
      accounts: AccountsReducer,
    }),
    applyMiddleware(routerMiddleware(history), thunk)
  )
}
